import enUS from 'antd/lib/locale/en_US';

import auth from './auth';
import collection from './collection';
import common from './common';
import customer from './customer';
import dashboard from './dashboard';
import device from './device';
import events from './events';
import gift from './gift';
import item from './item';
import pageError from './pageError';
import rankings from './rankings';
import report from './report';
import roles from './roles';
import server from './server';
import settings from './settings';
import user from './user';
import voucher from './voucher';

export default {
  ...enUS,
  ...common,
  ...server,
  ...auth,
  ...pageError,
  ...roles,
  ...user,
  ...device,
  ...customer,
  ...settings,
  ...item,
  ...collection,
  ...gift,
  ...events,
  ...rankings,
  ...voucher,
  ...dashboard,
  ...report,
};
